import React from 'react';
import Icon from '../../../components/AppIcon';

const VideoStats = ({ stats, formatWatchTime }) => {
  const statCards = [
    {
      title: 'Total Videos',
      value: stats?.totalVideos || 0,
      icon: 'Video',
      description: 'Uploaded across all songs'
    },
    {
      title: 'Total Plays',
      value: stats?.totalPlays || 0,
      icon: 'Play',
      description: 'All-time video plays'
    },
    {
      title: 'Watch Time',
      value: formatWatchTime(stats?.totalWatchTime || 0),
      icon: 'Clock',
      description: 'Total viewing duration'
    },
    {
      title: 'Engagement Rate',
      value: `${stats?.avgEngagement || 0}%`,
      icon: 'TrendingUp',
      description: 'Users who watched 5+ seconds'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {statCards?.map((stat, index) => (
        <div key={index} className="bg-card rounded-xl border border-border p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-muted-foreground">{stat?.title}</p>
              <p className="text-2xl font-bold text-foreground mt-2">{stat?.value}</p>
              {stat?.description && (
                <p className="text-sm text-muted-foreground mt-1">{stat?.description}</p>
              )}
            </div>
            <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-xl">
              <Icon name={stat?.icon} className="text-primary" size={24} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default VideoStats;